import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'verifyRequiredMeasurements'
})
export class VerifyRequiredMeasurementsPipe implements PipeTransform {

  transform(requiredMeasurements: {}[], ...args: unknown[]): boolean {
    let verify = true;
    requiredMeasurements.forEach(measurement => {
      const value = measurement[Object.keys(measurement)[0]];
      if (!value) {
        verify = false;
        return verify;
      }
    });
    return verify;

  }

}
